import React, { Fragment } from "react";
import cx from "classnames";
import styles from "./style.module.scss";

const TitlePage = ({ title, className }) => {
  return (
    <Fragment>
      <h2 className={cx(styles.title_headline, styles[className])}>
        <span className={styles.text}>{title}</span>
      </h2>
    </Fragment>
  );
};

export default TitlePage;
